const objectionActions = {
    GET_OBJ_NOTES : 'GET_OBJ_NOTES',
    SET_OBJ_NOTES : 'SET_OBJ_NOTES',

    GET_OBJ_QUESTIONS : 'GET_OBJ_QUESTIONS',
    SET_OBJ_QUESTIONS : 'SET_OBJ_QUESTIONS',

    // Raise / View Objection dialog: objView is set when the dialog is open.
    GET_OBJ_VIEW : 'GET_OBJ_VIEW',
    SET_OBJ_VIEW : 'SET_OBJ_VIEW',
    RAISE_OBJ : 'RAISE_OBJ',
    DELETE_OBJ : 'DELETE_OBJ',

    GET_OBJ_SUMMARY : 'GET_OBJ_SUMMARY',
    SET_OBJ_SUMMARY : 'SET_OBJ_SUMMARY',

    GET_OBJ_PAYMENT_SUMMARY : 'GET_OBJ_PAYMENT_SUMMARY',
    SET_OBJ_PAYMENT_SUMMARY : 'SET_OBJ_PAYMENT_SUMMARY',

    // Creates the Airpay order and redirects to Airpay, like the application fee cart.
    CREATE_OBJ_ORDER : 'CREATE_OBJ_ORDER',

    // Objection payment status page, shown when Airpay redirects back.
    VERIFY_OBJ_PAYMENT : 'VERIFY_OBJ_PAYMENT',
    SET_OBJ_PAYMENT_STATUS : 'SET_OBJ_PAYMENT_STATUS',

    // Objection fee receipts, shown on the Payment Receipts page.
    GET_OBJ_RECEIPT_LIST : 'GET_OBJ_RECEIPT_LIST',
    SET_OBJ_RECEIPT_LIST : 'SET_OBJ_RECEIPT_LIST',
};

export default objectionActions;
